'use client'

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { usePushNotifications } from '@/hooks/use-push-notifications'
import useStorage from '@/hooks/use-storage'
import {
  NOTIFICATIONS_MODAL_DISMISSED_KEY,
  USER_AUTH_STORAGE_KEY,
} from '@/hooks/use-storage/use-storage.constants'
import { isUserSessionValid } from '@/lib/user/auth'

import { NotificationSettings } from '../NotificationSettings'

export default function NotificationSettingsModal() {
  const { isSupported, isSubscribed, loading } = usePushNotifications()

  const { value: userAuth, storageLoaded: userAuthLoaded } =
    useStorage<UserAuth>(USER_AUTH_STORAGE_KEY)
  const {
    value: modalDismissed,
    setValue: setModalDismissed,
    storageLoaded: modalDismissedLoaded,
  } = useStorage<boolean>(NOTIFICATIONS_MODAL_DISMISSED_KEY, false)

  const storageLoaded = userAuthLoaded && modalDismissedLoaded
  const loaded = storageLoaded && !loading
  const isValidSession = isUserSessionValid(userAuth)

  const shouldShowModal =
    isSupported && !isSubscribed && !modalDismissed && loaded && isValidSession

  function onClose() {
    const expiry = new Date()
    expiry.setDate(expiry.getDate() + 30)
    setModalDismissed(true, { expiry })
  }

  function onOpenChange(open: boolean) {
    if (!open) {
      onClose()
    }
  }

  if (!shouldShowModal) {
    return null
  }

  return (
    <Dialog open={shouldShowModal} onOpenChange={onOpenChange}>
      <DialogContent className="border-primary/20 bg-background" aria-describedby={undefined}>
        <DialogHeader className="text-left">
          <DialogTitle className="text-primary m-0">Enable Notifications</DialogTitle>
        </DialogHeader>
        <NotificationSettings className="m-0 p-0" />
      </DialogContent>
    </Dialog>
  )
}
